import { LocationIcon } from '@hedepy/icons/refactor/Location'
import Link from 'next/dist/client/link'

import type { TherapistType } from '@/legacy-src/types/TherapistStateType'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Text } from '@/src/domains/design-system/components/Text'
import { getGoogleMapsHref } from '@/src/domains/google-maps/utils/getGoogleMapsHref'

import { TherapistCardIconText } from '../TherapistCardIconText'

export interface TherapistCardEventTypeUIProps {
  office: TherapistType['office']
}

export const TherapistCardEventTypeUI = ({ office }: TherapistCardEventTypeUIProps) => {
  const { t } = getTranslate()

  return (
    <TherapistCardIconText icon={<LocationIcon aria-label={t('component.therapist.appointment-type.label')} />}>
      <div className="flex flex-col">
        <span>
          {office
            ? t('component.therapist.appointment-type.offline')
            : t('component.therapist.appointment-type.online')}
        </span>
        {office ? (
          <Text variant="xs" element="address" className="mb-0 text-primary">
            <Link rel="noopener noreferrer" target="_blank" href={getGoogleMapsHref(office.location.address)}>
              {office.location.address}
            </Link>
          </Text>
        ) : null}
      </div>
    </TherapistCardIconText>
  )
}
